import React, { useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { useQuery } from 'react-query'
import useLocation from 'react-use/lib/useLocation'
import useAxios from '../../hooks/useAxios'
import useBrand from '../../hooks/useBrand'

type HrefLang = {
  domain: string
  brand_id: string
  url_path: string
  hreflang: string
}

const Hreflang = () => {
  const location = useLocation()
  const { hostname, protocol } = location
  const brand = useBrand()

  const axios = useAxios()
  const { data } = useQuery({
    enabled: !!brand.site_id,
    refetchOnWindowFocus: false,
    queryKey: ['hreflangs', brand.site_id],
    queryFn: async (): Promise<HrefLang[]> => {
      const { data } = await axios.get(
        `/api/v2/sites/${brand.site_id}/hreflang`
      )
      return data
    },
  })

  const hreflangs = useMemo(() => (data instanceof Array ? data : []), [data])

  const tags = useMemo(() => {
    const item = hreflangs.find((hreflang) =>
      hreflang.domain.includes(hostname || '')
    )
    return hreflangs
      .filter((hreflang) => hreflang.brand_id === item?.brand_id)
      .map(({ domain, hreflang, url_path }) => ({
        href: `${protocol}//${domain}${url_path}`,
        hreflang,
      }))
  }, [hreflangs, hostname, protocol])

  return (
    <Helmet>
      {tags.map((tag) => (
        <link
          key={tag.href}
          rel="alternate"
          href={tag.href}
          hrefLang={tag.hreflang}
        />
      ))}
    </Helmet>
  )
}

export default Hreflang
